export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";

export const SETUSER = "SETUSER";
export const SET_TOKEN = "SET_TOKEN";

export const API_START = "API_START";
export const API_FAIL = "API_FAIL";
export const API_COMPLETE = "API_COMPLETE";
export const SET_NULL = "SET_NULL";

export const SET_SM_DATA_START = "SET_SM_DATA_START";
export const SET_SM_DATA_SUCCESS = "SET_SM_DATA_SUCCESS";
export const SET_SM_DATA_FAIL = "SET_SM_DATA_FAIL";
export const SET_SM_DATA = "SET_SM_DATA";

// export const USER_CREATE = 'USER_CREATE';
export const USER_GET_SUCCESS = "USER_GET_SUCCESS";
export const USER_LIST_GET_SUCCESS = "USER_LIST_GET_SUCCESS";
export const USER_CREATE_SUCCESS = "USER_CREATE_SUCCESS";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";

export const HMG_GET_SUCCESS = "HMG_GET_SUCCESS";
export const HMG_CREATE_SUCCESS = "HMG_CREATE_SUCCESS";
export const HMG_UPDATE_SUCCESS = "HMG_UPDATE_SUCCESS";
export const HMG_GET_HOTELS_SUCCESS = "HMG_GET_HOTELS_SUCCESS";
export const HMG_GET_PROJECTS_HOTELS_SUCCESS =
  "HMG_GET_PROJECTS_HOTELS_SUCCESS";

export const HMG_MAIN_GET_SUCCESS = "HMG_MAIN_GET_SUCCESS";
export const HMG_MAIN_CREATE_SUCCESS = "HMG_MAIN_CREATE_SUCCESS";
export const HMG_MAIN_UPDATE_SUCCESS = "HMG_MAIN_UPDATE_SUCCESS";

export const HOTEL_GET_SUCCESS = "HOTEL_GET_SUCCESS";
export const HOTEL_CREATE_SUCCESS = "HOTEL_CREATE_SUCCESS";
export const HOTEL_UPDATE_SUCCESS = "HOTEL_UPDATE_SUCCESS";

export const ROLES_GET_SUCCESS = "ROLES_GET_SUCCESS";
export const ROLES_GET_MAIN_ROLE_ID_SUCCESS = 'ROLES_GET_MAIN_ROLE_ID_SUCCESS';
export const ROLES_LIST_GET_SUCCESS = "ROLES_LIST_GET_SUCCESS";
export const ROLE_CREATE_SUCCESS = "ROLE_CREATE_SUCCESS";
export const ROLE_UPDATE_SUCCESS = "ROLE_UPDATE_SUCCESS";

export const REPORTS_GET_SUCCESS = "REPORTS_GET_SUCCESS";

export const INDEXES_GET_SUCCESS = "INDEXES_GET_SUCCESS";
export const INDEXE_CREATE_SUCCESS = "INDEXE_CREATE_SUCCESS";
export const INDEXE_UPDATE_SUCCESS = "INDEXE_UPDATE_SUCCESS";

export const PMS_GET_SUCCESS = "PMS_GET_SUCCESS";

export const MAIN_ROLES_GET_SUCCESS = "MAIN_ROLES_GET_SUCCESS";
export const MAIN_ROLE_CREATE_SUCCESS = "MAIN_ROLE_CREATE_SUCCESS";
export const MAIN_ROLE_UPDATE_SUCCESS = "MAIN_ROLE_UPDATE_SUCCESS";

export const APPLICATIONS_GET_SUCCESS = "APPLICATIONS_GET_SUCCESS";

export const HOTELS_GROUPS_GET_SUCCESS = "HOTELS_GROUPS_GET_SUCCESS";
export const HOTELS_GROUP_CREATE_SUCCESS = "HOTELS_GROUP_CREATE_SUCCESS";
export const HOTELS_GROUP_UPDATE_SUCCESS = "HOTELS_GROUP_UPDATE_SUCCESS";

export const SOLUTIONS_GET_SUCCESS = "SOLUTIONS_GET_SUCCESS";

export const SIGNERS_GROUPS_GET_SUCCESS = "SIGNERS_GROUPS_GET_SUCCESS";
export const SIGNERS_GROUP_CREATE_SUCCESS = "SIGNERS_GROUP_CREATE_SUCCESS";
export const SIGNERS_GROUP_UPDATE_SUCCESS = "SIGNERS_GROUP_UPDATE_SUCCESS";
export const SIGNERS_GROUPS_HOTEL_UPDATE_SUCCESS =
  "SIGNERS_GROUPS_HOTEL_UPDATE_SUCCESS";

export const OUT_OF_OFFICE_CREATE_SUCCESS = "OUT_OF_OFFICE_CREATE_SUCCESS";
export const OUT_OF_OFFICE_UPDATE_SUCCESS = "OUT_OF_OFFICE_UPDATE_SUCCESS";

export const BULK_USER_CREATION_SUCCESS = "BULK_USER_CREATION_SUCCESS";

export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS";

export const COMMON_SET_HMG = "COMMON_SET_HMG";
export const COMMON_SET_MAIN_HMG = "COMMON_SET_MAIN_HMG";
export const COMMON_SET_SINGLE_HOTEL = "COMMON_SET_SINGLE_HOTEL";
export const COMMON_SET_HOTEL_LIST = "COMMON_SET_HOTEL_LIST";
export const COMMON_SET_PROJECT_LIST = "COMMON_SET_PROJECT_LIST";

export const QC_HMG_GET_SUCCESS = "QC_HMG_GET_SUCCESS";
export const QC_HOTEL_GET_SUCCESS = "QC_HOTEL_GET_SUCCESS";
export const QC_COMMON_SET_HMG = "QC_COMMON_SET_HMG";
export const QC_COMMON_SET_SINGLE_HOTEL = "QC_COMMON_SET_SINGLE_HOTEL";
export const QC_COMMON_SET_HOTEL_LIST = "QC_COMMON_SET_HOTEL_LIST";
export const QC_ENVLOP_TRIGR_SUCCESS = "QC_ENVLOP_TRIGR_SUCCESS";

export const QC_ENVIRON_IMPACT_GET_SUCCESS = "QC_ENVIRON_IMPACT_GET_SUCCESS";
export const QC_UPDATE_ENVIRON_IMPACT_SUCCESS =
  "QC_UPDATE_ENVIRON_IMPACT_SUCCESS";
export const QC_GET_PLATFORM_TYPE_SUCCESS = "QC_GET_PLATFORM_TYPE_SUCCESS";
export const QC_REPORTS_QC_SUCCESS = "QC_REPORTS_QC_SUCCESS";

export const SET_NOTIF_HMG_LIST = "SET_NOTIF_HMG_LIST";
export const SET_NOTIF_COMPLETE_SUCCESS = "SET_NOTIF_COMPLETE_SUCCESS";

export const BULK_REPORT_CATEGORY_CREATION_SUCCESS =
  "BULK_REPORT_CATEGORY_CREATION_SUCCESS";

export const MAPPED_HMG_ROLES = "MAPPED_HMG_ROLES";
